'use strict';
// var debounce = require('lodash/debounce');
// var UP_KEY = 38;
// var DOWN_KEY = 40;
var minChars = 3;
var searchedWord;
var endpoint = $('.js-search').data('url');

function specialCharChecker (toCheck) {
    const forbiddenChar = ['<', '>', '&', '%', '(', ')', '|', '!', '$', '^', '`', '?'];
    var isValid = true;
    forbiddenChar.forEach(element => {
        if (toCheck.indexOf(element) !== -1) {
            isValid = false;
            return true;
        }
    });
    var $errorField = $(document).find('#search-assistive-text .cc-error-message');
    if (!isValid && toCheck.length > 0) {
        if ($errorField.hasClass('d-none')) $errorField.removeClass('d-none');
        $(document).find('.js-search-control').data('isvalid', 'false');
    } else {
        if (!$errorField.hasClass('d-none')) $errorField.addClass('d-none');
        $(document).find('.js-search-control').data('isvalid', 'true');
    }
    return isValid;
}

// function processResponse(response) {
//     $('body').removeClass('cc-blocked');
//     $(document).find('.js-suggestions').html(response);
//     $(document).find('#maincontent').hide();
// }

// function getSuggestions(scope) {
//     var searchWord = $(scope).val();
//     // NEC-3045 add control to special char
//     var validChar = specialCharChecker(searchWord);
//     if (searchWord.length >= minChars && searchWord !== searchedWord && validChar) {
//         searchedWord = searchWord;
//         // $.spinner().start();
//         $.ajax({
//             context: scope,
//             url: endpoint + encodeURIComponent(searchWord),
//             method: 'GET',
//             success: processResponse,
//             error: function () {
//             }
//         });
//     } else {
//     }
// }

module.exports = function() {
    $(document).on('click', '.js-search', function (e) {
        e.preventDefault();
        $(document).find('.js-headerSearch').toggleClass('cc-headerSearch--open');
        $(document).find('.js-headerOverlay').toggleClass('cc-header__overlay--active');

        $(document).on('keypress', function (e) {
            if ($('.cc-headerSearch').hasClass('cc-headerSearch--open') && e.which === 13) {
                $('body').removeClass('cc-blocked');
                $(document).find('.cc-headerSearch').removeClass('cc-headerSearch--open');
                $(document).find('.js-headerOverlay').removeClass('cc-header__overlay--active');
            }
        });
    });

    $(document).on('click', '.js-closeSearch, .js-headerOverlay', function (e) {
        e.preventDefault();
        $(document).find('.js-headerSearch').removeClass('cc-headerSearch--open');
        $(document).find('.js-headerOverlay').removeClass('cc-header__overlay--active');
    });

    // $('input.search-field').each(function () {
    //     /**
    //      * Use debounce to avoid making an Ajax call on every single key press by waiting a few
    //      * hundred milliseconds before making the request. Without debounce, the user sees the
    //      * browser blink with every key press.
    //      */
    //     var debounceSuggestions = debounce(getSuggestions, 600);
    //     $(this).on('keyup focus', function (e) {
    //         switch (e.which) {
    //         case DOWN_KEY:
    //             e.preventDefault();
    //             break;
    //         case UP_KEY:
    //             e.preventDefault();
    //             break;
    //         default:
    //             debounceSuggestions(this, e);
    //         }
    //     });
    // });
};
